import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API, withCredentials: true });

export const fmt = (cents) => `$${((cents || 0) / 100).toFixed(2)}`;

export function apiError(e) {
  const d = e?.response?.data?.detail;
  if (!d) return "Something went wrong. Try again.";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => (x && x.msg) || JSON.stringify(x)).join(" ");
  return String(d.msg || d);
}
